import { Variant } from "../types/onboarding";

export function getUniqueAttributeNames(variants: Variant[]) {
    const attributeNames = new Set<string>();
  
    variants.forEach(variant => {
      variant.attributes?.forEach((attr: any) => {
        if (attr.name) {
          attributeNames.add(attr.name);
        }
      });
    });
  
    return Array.from(attributeNames);
  }
  